import React from 'react';
import ProtectedPageSidebar from '../../components/Sidebar/ProtectedPageSidebar';
import DownloadOptions from '../../features/DownloadCenter/components/index';

export const DownloadCenter = () => {
  return (
    <>
      <ProtectedPageSidebar />
      <DownloadOptions />
    </>
  );
};

export default DownloadCenter;
